export enum HisSearchCriteriaSetStateType {
    ADDED,
    CANCELED,
    CHANGED_SEARCH,
    DELETED,
    LOADED,
    SAVED

}
